module.exports = __webpack_public_path__ + "img/LIST.9fde5499.svg";